exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stack {\r\n  position: absolute;\r\n  z-index: 0;\r\n  width: 129rem;\r\n  height: 171.75rem;\r\n}\r\n.stack .count {\r\n  position: absolute;\r\n  bottom: 16rem;\r\n  right: 12rem;\r\n  width: 30rem;\r\n  height: 30rem;\r\n  justify-content: center;\r\n  align-items: center;\r\n  display: flex;\r\n  background-color: rgba(255, 255, 255, 0.7);\r\n  font-family: \"Contrail One\", cursive;\r\n  font-size: 20rem;\r\n  border-radius: 50%;\r\n}\r\n", ""]);

// exports
